(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CategoryRankingController', CategoryRankingController);

    CategoryRankingController.$inject = ['$scope', '$state', 'CategoryRanking'];

    function CategoryRankingController ($scope, $state, CategoryRanking) {
        var vm = this;

        vm.categoryRankings = [];

        loadAll();

        function loadAll() {
            CategoryRanking.query({
                size: 100000,
                sort: ['profileCategory', 'priority']
            }, function(result) {
                vm.categoryRankings = result;
                vm.searchQuery = null;
            });
        }
    }
})();
